<template>
  <v-footer
    id="core-footer"
    absolute
    height="40"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          :target="link.target"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright category">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="http://pipefish.com.au/"
        target="_blank">Pipefish</a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/dashboard', target: '' },
      { name: 'About Us', Link: 'http://pipefish.com.au/#about-section', target: '_blank' },
      { name: 'Contact', Link: 'http://pipefish.com.au/#social-section', target: '_blank' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}

</style>
